import type { TwitterFormValues } from './twitter.schema';

export const getTwitterFormDefaultValues = (app: string): TwitterFormValues => ({
  currentStep: 0,
  app,
  accountId: '',
  selectedCreatives: [],
  selectedCreativesOnly: false,
  filterCreativeByName: [],
  selectedCampaigns: [],
  selectedCampaignsOnly: false,
  filterCampaignsByName: [],
  selectedLineItems: [],
  filterLineItemsByName: [],
  adSettings: {},
  $creativesRows: [],
  $lineItemsData: [],
  $adSettingsData: undefined,
});
